var map = {
	"./Copy of MOON_11zon.jpg": 9427,
	"./Copy of OPENROCKET.JPG": 4719,
	"./Copy of QUANTUMCOMPUTING_11zon.jpeg": 6452,
	"./Copy of STAR_GAZING_11zon.jpg": 1799,
	"./Copy of TELESCOPE_11zon.jpg": 2390,
	"./Copy of VR_11zon.jpg": 9604
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5682;